/* apps/viewer/src/app/toc-items/note-module/note/note.component.scss */
.ori-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0);
}
.ori-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1);
}
.ori-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2);
}
.ori-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3);
}
.ori-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4);
}
.ori-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5);
}
.ori-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6);
}
.ori-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7);
}
.ori-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8);
}
.ori-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9);
}
.ori-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10);
}
.ori-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11);
}
.ori-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12);
}
.ori-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13);
}
.ori-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14);
}
.ori-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15);
}
.ori-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16);
}
.ori-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17);
}
.ori-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18);
}
.ori-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19);
}
.ori-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20);
}
.ori-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21);
}
.ori-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22);
}
.ori-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23);
}
.ori-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24);
}
:host {
  display: block;
  margin: 10px;
}
:host form {
  align-items: flex-start;
  cursor: pointer;
}
:host form ::ng-deep .mat-form-field-disabled .mdc-line-ripple {
  display: none;
}
:host form ::ng-deep #content_note .mdc-text-field--disabled .mat-mdc-form-field-infix,
:host form ::ng-deep #title_note .mdc-text-field--disabled .mat-mdc-form-field-infix {
  line-height: 18px;
  min-height: -moz-fit-content;
  min-height: fit-content;
  padding-top: 0;
}
:host form ::ng-deep .mat-mdc-select-disabled .mat-mdc-select-value {
  color: #7f7f7f;
}
:host textarea {
  font-size: 14px;
  margin: 0;
  min-height: 28px;
  overflow: hidden;
  padding: 0;
}
:host input {
  font-size: 16px;
}
:host .add-media-button {
  margin: 10px 0 20px;
}
:host .medias-panel {
  flex-grow: 1;
  font-size: 14px;
  margin: 0;
  padding-inline-start: 20px;
}
:host .medias-panel button {
  height: 35px;
  padding: 0;
}
:host .medias-panel-label {
  cursor: pointer;
  font-size: 12px;
}
:host .media-link {
  cursor: pointer;
  margin-right: 10px;
  text-decoration: underline;
  word-break: break-word;
}
:host .media-list-item {
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 48px;
}
mat-form-field {
  width: 100%;
}
.note__infos {
  align-items: center;
  color: #7f7f7f;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  font-size: 11px;
}
.note__infos .mat-icon {
  height: 20px;
  margin-right: 5px;
  width: 20px;
}
.note__infos span {
  margin: 0 5px;
}
.note-anchor-container {
  font-size: 13px;
  margin: 5px 0;
}
.note__title {
  font-weight: 700;
  white-space: pre-line;
  word-break: break-all;
}
.note__anchor {
  font-size: 13px;
  margin: 5px 0;
}
.note__area {
  white-space: pre-line;
  word-break: break-all;
}
.note--dmc {
  color: #7f7f7f;
  font-size: 11px;
  margin: 0;
}
.note--submit {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
}
.note--submit .note--cancel {
  margin-right: 8px;
}
.note--submit button[disabled] {
  background: #aaa;
  color: #fafafa;
}
.note-footer {
  align-items: end;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;
  width: 100%;
}
.note-footer .note_infos {
  font-size: 12px;
  font-weight: normal;
}
.note--delete {
  background: transparent;
  border: none;
}
.note__actions button {
  padding: 0;
}
.note__content {
  display: block;
}
.note--actions-export {
  align-items: center;
  display: flex;
  position: absolute;
  right: 0;
  top: 0;
}
.note--te {
  font-size: x-small;
  margin-left: auto;
  text-align: right;
  width: max-content;
}
.note--te:hover {
  cursor: pointer;
}
.mat-mdc-card {
  padding: 10px;
}
mat-card:not([class*=note--edit]) mat-form-field {
  width: 100%;
}
mat-card:not([class*=note--edit]) mat-form-field ::ng-deep .mat-mdc-form-field-infix {
  border: none;
  padding: 0;
}
mat-card:not([class*=note--edit]) mat-form-field ::ng-deep .mat-mdc-form-field-infix:first-of-type {
  margin-bottom: 5px;
}
mat-select {
  align-items: center;
  display: flex;
  height: 25px;
  max-width: 100px;
}
::ng-deep .note__export-menu {
  max-width: none !important;
}
:host(.not-applicable):not(.from-drawer):not(.from-fulltext) {
  text-decoration: line-through;
}
:host(.not-applicable):not(.from-drawer):not(.from-fulltext) input,
:host(.not-applicable):not(.from-drawer):not(.from-fulltext) textarea {
  text-decoration: line-through;
}
:host(.not-applicable.hide-not-applicable):not(.from-drawer):not(.from-fulltext) {
  display: none !important;
}
.note-card {
  border-style: solid;
  border-width: 1px 1px 1px 8px;
}
button:disabled {
  background: transparent;
}
button:disabled .mat-icon {
  color: #aaa !important;
}
.info {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 10px;
  width: 100%;
}
.info .key {
  flex: 0 0 200px;
  font-size: 14px;
  font-weight: bold;
  width: 200px;
}
.info .key .value {
  flex: 1;
  min-width: 220px;
}
@media screen {
  .info.hide-panel {
    display: none;
  }
}
.note-warning {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
}
.note-warning .inline-note-warning-text {
  font-size: 15px;
  padding-left: 10px;
}
@media print {
  .note--actions-export,
  .medias-panel-label {
    display: none;
  }
}
/*# sourceMappingURL=note.component.css.map */
